"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_2 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_3 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_4 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_5 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_6 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_7 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_8 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_9 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_10 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_11 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_12 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_13 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_14 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_15 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_16 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_17 = require("@biomemakers/bmk_ui_framework");
const floating_vue_1 = require("floating-vue");
const lucide_vue_next_1 = require("lucide-vue-next");
const trans_1 = require("@common/tsutils/trans");
const axios_1 = __importDefault(require("axios"));
const StudySummaryDownload_vue_1 = __importDefault(require("../StudySummaryDownload.vue"));
let TableStudies = class TableStudies extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.projectList = [];
        this.textSearch = '';
        this.criteria = '';
        this.direction = 0;
        this.currentStudy = null;
        this.currentProject = null;
        this.showStudyDownload = false;
        this.theadElements = [
            {
                name: (0, trans_1.trans)('results.projects.table.type'),
                slug: 'type',
                order: false,
            },
            {
                name: (0, trans_1.trans)('results_view_map.trials.name'),
                slug: 'name',
                order: false,
            },
            {
                name: 'Report at',
                slug: 'report_at',
                order: false,
            },
            {
                name: 'Version',
                slug: 'version',
                order: false,
            },
            {
                name: (0, trans_1.trans)('results_view_map.trials.acts'),
                slug: 'acts',
                order: false,
            },
        ];
        this.criteriaArr = [];
    }
    // @Prop() study_summary?: boolean;
    // @Prop() study_options?: any;
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    created() {
        axios_1.default.get('/results/api/project/studies', {
            params: { projects: this.projects.map((project) => project.project_id).join(',') },
        })
            .then((res) => this.projectList = res.data)
            .catch(function (error) {
            console.error(error);
        });
    }
    showReport(projectId, studyId) {
        window.location.href = `/results/project/${projectId}/summary/${studyId}`;
    }
    shortMixpanel(value) {
        const originModule = localStorage.getItem('currentModule');
        const criteria = value;
        let direction = this.direction;
        this.criteriaArr.push(criteria);
        if (this.criteriaArr.length >= 2) {
            if (this.criteriaArr[0] !== this.criteriaArr[1]) {
                direction = 0;
            }
            this.criteriaArr.shift();
        }
        if (direction === 0) {
            direction = 1;
        }
        else if (direction === 1) {
            direction = -1;
        }
        else if (direction === -1) {
            direction = 0;
        }
    }
    chooseSortable(c) {
        this.updateSortableStudies(c);
    }
    updateSortableStudies(newCriteria) {
        const directions = [-1, 0, 1];
        if (newCriteria !== this.criteria) {
            this.criteria = newCriteria;
            this.direction = directions[2];
        }
        else {
            let dirIx = directions.findIndex((d) => d === this.direction);
            dirIx === directions.length - 1 ? (dirIx = 0) : (dirIx = dirIx + 1);
            this.direction = directions[dirIx];
        }
        this.updateSortStudies();
    }
    downloadStudy(study, project) {
        this.showStudyDownload = true;
        this.currentStudy = study;
        this.currentProject = project;
    }
    dismissStudyDownload() {
        this.showStudyDownload = false;
        this.currentStudy = null;
        this.currentProject = null;
    }
    updateSortStudies() {
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Array, default: [] })
], TableStudies.prototype, "projects", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableStudies.prototype, "theme", void 0);
TableStudies = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            StudyLogo: bmk_ui_framework_17.StudyLogo,
            TrialsLogo: bmk_ui_framework_1.TrialsLogo,
            RateLogo: bmk_ui_framework_1.RateLogo,
            YieldLogo: bmk_ui_framework_1.YieldLogo,
            FarmLogo: bmk_ui_framework_1.FarmLogo,
            DiseasesLogo: bmk_ui_framework_1.DiseasesLogo,
            ManagementLogo: bmk_ui_framework_1.ManagementLogo,
            TableHeader: bmk_ui_framework_2.TableHeader,
            TableHeaderCell: bmk_ui_framework_3.TableHeaderCell,
            TableBmk: bmk_ui_framework_4.TableBmk,
            TableBody: bmk_ui_framework_5.TableBody,
            TableBodyRow: bmk_ui_framework_6.TableBodyRow,
            TableBodyCell: bmk_ui_framework_7.TableBodyCell,
            Modal: bmk_ui_framework_8.Modal,
            ViewZero: bmk_ui_framework_11.ViewZero,
            MagnifyingGlassIcon: bmk_ui_framework_9.MagnifyingGlassIcon,
            CrossIcon: bmk_ui_framework_10.CrossIcon,
            Button: bmk_ui_framework_14.Button,
            InputField: bmk_ui_framework_15.InputField,
            DateStylized: bmk_ui_framework_16.DateStylized,
            Toasts: bmk_ui_framework_12.Toasts,
            Tag: bmk_ui_framework_13.Tag,
            StudySummaryDownload: StudySummaryDownload_vue_1.default,
            Dropdown: floating_vue_1.Dropdown,
            Mail: lucide_vue_next_1.Mail,
            Lock: lucide_vue_next_1.Lock,
            Eye: lucide_vue_next_1.Eye,
            ArrowUpRight: lucide_vue_next_1.ArrowUpRight,
            ArrowRight: lucide_vue_next_1.ArrowRight,
            ArrowDown: lucide_vue_next_1.ArrowDown,
            QrCode: lucide_vue_next_1.QrCode,
            Key: lucide_vue_next_1.Key,
            LoaderBuild: bmk_ui_framework_1.LoaderBuild,
        },
    })
], TableStudies);
exports.default = TableStudies;
